const Home = () => {

  window.addEventListener("load", () => {
    setTimeout(() => {
      var modal = document.querySelector(".access-count");
      modal.classList.toggle("active");
      modal.classList.add("blur");
    }, 500);
  })


  const target = document.querySelector('.component-2');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('animated') && entry.intersectionRatio >= 0.9) {
        document.querySelector('.access-count').classList.remove('active');
        document.body.classList.add('show-signin-bar');
      }
    });
  }, { threshold: 0.9, rootMargin: "0px" });

  observer.observe(target);
  
}

export default Home
